import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  CardHeader,
  Avatar,
  IconButton,
} from '@material-ui/core';
import {
  UserMemberPointStatus,
  UserMemberPointStatusText,
  UserMemberPointTypeText,
} from '../../data/common';
import { formatNumberComma } from '../../Util/Util';
import moment from 'moment';
import CancelIcon from '@material-ui/icons/Cancel';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';

const PointView = (props) => {
  const { point, closeDrawer } = props;

  const isUsePoint = point.points < 0;

  const pointDate = moment(point.bonusDate);

  const handleClose = () => {
    closeDrawer();
  };

  return (
    <div className="bonus__view">
      <div className="bonus__close-view">
        關閉
        <IconButton onClick={handleClose}>
          <CancelIcon />
        </IconButton>
      </div>

      {point && (
        <Grid
          container
          direction="column"
          justifycontent="flex-start"
          alignItems="stretch"
          spacing={3}>
          <Grid item xs={12}>
            <Card variant="outlined">
              <CardHeader
                avatar={
                  <Avatar
                    className={
                      isUsePoint
                        ? 'bonus__avatar--use'
                        : 'bonus__avatar--reward'
                    }>
                    P
                  </Avatar>
                }
                title={<Typography variant="h3">{point.points}</Typography>}
                subheader="點數"
              />

              <CardContent>
                <Grid
                  container
                  direction="row"
                  justifycontent="space-around"
                  alignItems="stretch"
                  spacing={2}>
                  <Grid item xs={6}>
                    <Typography color="textSecondary">類型</Typography>
                    <Typography variant="h6">
                      {UserMemberPointTypeText[point.type]}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography color="textSecondary">發票金額</Typography>
                    <Typography variant="h6">
                      $ {formatNumberComma(point.invoiceAmount)}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography color="textSecondary">狀態</Typography>
                    <Typography variant="h6">
                      {UserMemberPointStatusText[point.status]}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography color="textSecondary">建立者</Typography>
                    <Typography variant="h6">{point.createUser}</Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography color="textSecondary">建立日期</Typography>
                    <Typography variant="h6">
                      {pointDate.format('YYYY-MM-DD HH:mm:ss')}
                    </Typography>
                  </Grid>
                </Grid>

                <Typography
                  variant="body2"
                  component="p"
                  className="bonus__comment">
                  {point.comment}
                </Typography>

                {point.status === UserMemberPointStatus.DELETE && (
                  <>
                    <Typography color="error">刪除原因</Typography>
                    <Typography
                      variant="body2"
                      component="p"
                      className="bonus__comment bonus__comment--error">
                      {point.auditComment}
                    </Typography>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card variant="outlined">
              <CardHeader
                avatar={
                  <Avatar>
                    <AccountCircleOutlinedIcon />
                  </Avatar>
                }
                title={
                  <Typography variant="h3">
                    {point.customer.realName}
                  </Typography>
                }
                subheader={`ID ${point.customer.id}`}
              />

              <CardContent>
                <Grid
                  container
                  direction="row"
                  justifycontent="space-around"
                  alignItems="stretch"
                  spacing={2}>
                  <Grid item xs={12}>
                    <Typography color="textSecondary">手機</Typography>
                    <Typography variant="h6">
                      {point.customer.cellPhone}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography color="textSecondary">email</Typography>
                    <Typography variant="h6">{point.customer.email}</Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default PointView;
